const setAllFundsValues = payload => ({
  type: "SET_All_FUNDS_VALUES",
  payload
});

const setCurrentFund = payload => ({
  type: "SET_CURRENT_FUND",
  payload
});

const setFundByDate = payload => ({
  type: "SET_FUND_BY_DATE",
  payload
});

export default {
  setAllFundsValues,
  setCurrentFund,
  setFundByDate
};
